module.exports = __webpack_public_path__ + "static/media/gbqq.21e52999.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/gbqq.mp3
// module id = 28
// module chunks = 0